module.exports = __webpack_public_path__ + "img/logo2.3088dae3.png";